import { button } from './button';
import { card } from './card';
import { dialog } from './dialog';

export const components = {
	button,
	card,
	dialog,
};
